import { render, staticRenderFns } from "./TableNewsAndEvents.vue?vue&type=template&id=489916f7"
import script from "./TableNewsAndEvents.vue?vue&type=script&lang=js"
export * from "./TableNewsAndEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports